<template>
    <div id="layoutDefault">
        <div id="layoutDefault_content">
            <main>
                <nav class="navbar navbar-marketing navbar-expand-lg bg-innovation navbar-dark fixed-top">
                    <div class="container">
                        <a class="navbar-brand text-white" href="" v-on:click.prevent="Nada">PSICOFAST</a><button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"><i class="fas fa-bars"></i></button>
                        <div class="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul class="navbar-nav ml-auto mr-lg-5">
                                <li class="nav-item">
                                    <a 
                                        class="nav-link" 
                                        href="" 
                                        v-on:click.prevent="Nada">
                                        {{menu.empleado.nombre}}
                                    </a>
                                </li>
                                <li class="nav-item d-md-block d-none">
                                    <a class="nav-link" href="" v-on:click.prevent="Nada">-</a>
                                </li>
                                <li class="nav-item">
                                    <a 
                                    class="nav-link" 
                                    href="" 
                                    v-on:click.prevent="Nada">
                                       {{menu.cliente.nombre}} 
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>
                <section class="bg-light pt-5 mt-5">
                    <div class="container">
                        <router-view />
                    </div>
                </section>
            </main>
        </div>
        <div id="layoutDefault_footer bg-light">
            <footer class="footer mt-auto bg-light">
                <div class="container bg-light">
                    <div class="row align-items-center bg-light">
                        <div class="col-md-6 small">Copyright &copy; PSICOFAST 2021</div>
                        <div class="col-md-6 text-md-right small">
                            <a target="_blank" href="https://psicofast.com">
                              Política de Privacidad
                            </a>
                            &middot;
                            <a target="_blank" href="https://psicofast.com">
                              Términos y condiciones
                            </a>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    </div>
</template>

<script>
import {mapActions,mapState} from 'vuex';
export default {
  data () {
    return {
      
    }
  },
  methods:{
    Terminar(){
        swal('Listo','Gracias por participar','success');
    },
    EjecutarRuta(route_name){
      this.$router.push({name:route_name});
    },
    Nada(){}
  },
  computed:{
    ...mapState(['menu'])
  },
  mounted(){
    $('body').removeClass('bg-innovation');
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/AppMenu/Menu/Menu.vue